export default __webpack_public_path__ + "static/media/gynecology.46a99d12.png";